<template>
    <div>
        <principe></principe>
        <demarche></demarche>
        <zerowaste></zerowaste>
    </div>
</template>

<script>
import Principe from './modules/Principe'
import Demarche from './modules/Demarche'
import Zerowaste from './modules/Zerowaste'
export default {
  name: 'modules',
  components: {
    Principe,
    Demarche,
    Zerowaste,
  },
}
</script>
